import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Paper, Box, Typography, Divider, IconButton, styled } from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckMenuList from '../../components/usermenumng/CheckMenuList'

import UserGoalSettingTemplate from '../../components/goalsetting/UserGoalSettingTemplate';
import { unloadEmployee, viewEmployee } from '../../modules/empModule/employee';
import UserGoalFormContainer from './UserGoalFormContainer';
import UserGoalListContainer from './UserGoalListContainer';


const WhiteIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.background.paper,
    '&:hover': {
        backgroundColor: theme.palette.getContrastText(theme.palette.background.paper),
    },
}));



const UserGoalSettingContainer = () => {
    const { deptId, id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const { employee, error, loading } = useSelector(
        ({ empModule, loading }) => ({
            employee: empModule.employee.employee,
            error: empModule.employee.error,
            loading: loading['employee/VIEW_EMPLOYEE']
        }),
    );




    useEffect(() => {
        dispatch(viewEmployee(id));

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadEmployee());
        };
    }, [dispatch, deptId, id]);

    const handleGoBack = () => {
        navigate(`/goalsetting/${deptId}`)
    }

    return (
        <UserGoalSettingTemplate user={employee} loading={loading} error={error}>
            <Paper>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        backgroundColor: '#424242',
                        color: '#fff',
                        py: 1,
                        px: 2,
                        marginBottom: 2,
                    }}
                >
                    <Box sx={{ mr: 1 }}>
                        <WhiteIconButton size="small" onClick={handleGoBack}>
                            <ArrowBackIcon aria-label="goBack" />
                        </WhiteIconButton>
                    </Box>
                    <Typography variant="subtitle2" component="div">
                        {employee?.usrNm} {employee?.gradeNm} ({employee?.dptNm}) 목표 설정
                    </Typography>
                </Box>
                <UserGoalListContainer user={employee} />
            </Paper>

        </UserGoalSettingTemplate>
    )
}

export default UserGoalSettingContainer